import { Mixin } from 'ts-mixer'

import {JavelinaAccumulatorClient} from './JavelinaAccumulatorClient'
import {JavelinaAuthClient} from './JavelinaAuthClient'
import {JavelinaClaimClient} from './JavelinaClaimClient'
import {JavelinaClientClient} from './JavelinaClientClient'
import {JavelinaMemberClient} from './JavelinaMemberClient'
import {JavelinaLocationClient} from './JavelinaLocationClient'
import {JavelinaProviderClient} from './JavelinaProviderClient'
import {JavelinaProxyClient} from './JavelinaProxyClient'

export class JavelinaClient extends Mixin(
    JavelinaAccumulatorClient, 
    JavelinaAuthClient, 
    JavelinaClaimClient, 
    JavelinaClientClient,
    JavelinaLocationClient, 
    JavelinaMemberClient, 
    JavelinaProviderClient, 
    JavelinaProxyClient
) {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || 'javelina-adapter-key', 
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }
}
